export const TICKETMASTER_CONFIG = {
  // Paramètres de l'API
  API: {
    BASE_URL: import.meta.env.VITE_TICKETMASTER_API_URL || 'https://app.ticketmaster.com/discovery/v2',
    KEY: import.meta.env.VITE_TICKETMASTER_API_KEY,
    RATE_LIMIT: {
      DAY: Number(import.meta.env.VITE_TICKETMASTER_RATE_LIMIT_DAY) || 5000,
      MINUTE: Number(import.meta.env.VITE_TICKETMASTER_RATE_LIMIT_MINUTE) || 100
    }
  },

  // Classifications pour filtrage
  CLASSIFICATIONS: {
    MUSIC: 'KZFzniwnSyZfZ7v7nJ',
    ARTS: 'KZFzniwnSyZfZ7v7na',
    SPORTS: 'KZFzniwnSyZfZ7v7nE',
    FAMILY: 'KZFzniwnSyZfZ7v7n1'
  },

  // Genres à exclure
  EXCLUDED_GENRES: [
    'K8vZ9171qlf', // Parking
    'K8vZ9171-7l'  // Meet & Greet
  ]
} as const;